// This file was generated using `pay js:run gql-v1 --type=mutation --name=CreateIdentityChallenge --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import type {
  V1MutationOptionsWithoutVariables,
  V1MutationOptions,
  V1MutationReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {useV1Mutation} from '@stripe-internal/data-v1';
import {gql} from '@sail/data';

import type {GraphQlDocument, ApolloError} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1ConnectIdentityChallengeInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  mutation CreateIdentityChallengeMutation(
    $input: OpenapiPostV1ConnectIdentityChallengeInput
    $v1Context: V1ContextInput!
  ) {
    v1ConnectIdentityChallenge(input: $input, v1Context: $v1Context) {
      auth_attempt_id
      verification_session
    }
  }
`;

export const createIdentityChallengeMutation: CreateIdentityChallengeMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const createIdentityChallengeMutationOptions: V1MutationOptionsWithoutVariables<CreateIdentityChallengeMutationDocument> =
  {
    expectedErrors: [
      'merchant_not_eligible_for_identity_verification',
      'merchant_requires_legal_entity_cooldown_for_identity_verification',
      'merchant_requires_legal_entity_cooldown_for_identity_verification_without_date',
    ],

    // TODO: This is a legacy behavior that was present in the original Apollo
    // wrappers and is not standard. If you are not using this error for anything
    // feel free to remove it (More info: go/throw-errors-on-mutations)
    onError(error: ApolloError) {
      throw error;
    },
  };

export default function useCreateIdentityChallengeMutation(
  options: V1MutationOptions<CreateIdentityChallengeMutationDocument> = {},
): V1MutationReturn<CreateIdentityChallengeMutationDocument> {
  return useV1Mutation(
    createIdentityChallengeMutation,
    Object.assign({}, createIdentityChallengeMutationOptions, options),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type CreateIdentityChallengeMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1ConnectIdentityChallengeInput>;
  v1Context: V1ContextInput;
}>;

export type CreateIdentityChallengeMutationData = {
  readonly __typename: 'Mutation';
  readonly v1ConnectIdentityChallenge: {
    readonly __typename: 'OpenapiConnectAuthResourcesIdentityChallenge';
    readonly auth_attempt_id: string;
    readonly verification_session: string | null;
  } | null;
};

const createIdentityChallengeMutationPermissions = {} as const;

doc.permissions = createIdentityChallengeMutationPermissions;

export type CreateIdentityChallengeMutationPermissions = V1PermissionToken<
  typeof createIdentityChallengeMutationPermissions
>;

export type CreateIdentityChallengeMutationDocument = GraphQlDocument<
  CreateIdentityChallengeMutationData,
  CreateIdentityChallengeMutationVariables,
  CreateIdentityChallengeMutationPermissions
>;
